module.exports = __webpack_public_path__ + "static/img/buildings-background.dcf986e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buildings-background.jpg
// module id = l6vF
// module chunks = 1